import { actionNameGenerator } from "../../../utils/commonUtil";

const domainPrefix = "txn";
const txnActionNameGenerator = actionNameGenerator(domainPrefix);

export const fetchTransactionDataType = txnActionNameGenerator('fetchTransactionData');
export const fetchTransactionTabDataType = txnActionNameGenerator('fetchTransactionTabData');
export const filterGridDataType = txnActionNameGenerator('filterGridData');
export const filterSortType = txnActionNameGenerator('filterSort');
export const radioChangeType = txnActionNameGenerator('radioChange');
export const tabChangeType = txnActionNameGenerator('tabChange');
export const filterDataPrintType = txnActionNameGenerator('filterDataPrint');
export const fetchOtherTransactionType = txnActionNameGenerator('fetchOtherTransaction');
export const fetchAccountDetailsLoadingType = txnActionNameGenerator('fetchAccountDetailsLoading');
export const fetchAccountDetailsSuccessType = txnActionNameGenerator('fetchAccountDetailsSuccess');
export const fetchTransactionDataLoadingType = txnActionNameGenerator('fetchTransactionDataLoading');
export const fetchTransactionDataSuccessType = txnActionNameGenerator('fetchTransactionDataSuccess');
export const fetchBalanceLoadingType = txnActionNameGenerator('fetchBalanceLoading');
export const fetchBalanceSuccessType = txnActionNameGenerator('fetchBalanceSuccess');
export const fetchFeeLoadingType = txnActionNameGenerator('fetchFeeLoading');
export const fetchFeeSuccessType = txnActionNameGenerator('fetchFeeSuccess');
export const fetchFeeContentLoadingType = txnActionNameGenerator('fetchFeeContentLoading');
export const fetchFeeContentSuccessType = txnActionNameGenerator('fetchFeeContentSuccess');
export const fetchTransactionTabLoadingType = txnActionNameGenerator('fetchTransactionTabLoading');
export const fetchTransactionTabSuccessType = txnActionNameGenerator('fetchTransactionTabSuccess');
export const fetchOtherTransactionLoadingType = txnActionNameGenerator('fetchOtherTransactionLoading');
export const fetchOtherTransactionSuccessType = txnActionNameGenerator('fetchOtherTransactionSuccess');
export const fetchOtherTransactionErrorType = txnActionNameGenerator('fetchOtherTransactionError');
export const clearOtherTransactionType = txnActionNameGenerator('clearOtherTransaction');
export const exportTxnDataType = txnActionNameGenerator('exportTxn');
